import React from 'react';
// Components
import GeneralMainSection from '../general/GeneralMainSection';
import GeneralFooter from '../general/GeneralFooter';
// Images
import CarpentryImage from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-construction-roof-construction-kitchen-carpenrty.jpg';
import CarpentryImage2 from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-tool.jpg';
import CarpentryImage3 from '../../assets/images/main/ascari-building-contractors-landscaping-and-floor.jpg';

function CarpentryPageMainContainer() {
  const carpentryPageData = {
    headerSentence: 'Expert Carpentry & Custom Woodwork',
    description:
      'At Ascari Building Contractors, we provide high-quality carpentry services for both residential and commercial projects. Our skilled team delivers precision craftsmanship, whether it’s structural work, bespoke furniture, or detailed finishing touches.',
    services: [
      {
        title: 'Structural Carpentry',
        description:
          'Expert framing, joist installations, and timber construction for extensions and renovations.',
      },
      {
        title: 'Custom Furniture & Joinery',
        description:
          'Bespoke shelving, wardrobes, staircases, and cabinetry tailored to your space and style.',
      },
      {
        title: 'Flooring & Skirting',
        description:
          'Precision installation of solid wood, engineered, and laminate flooring with matching skirting boards.',
      },
      {
        title: 'Doors & Windows',
        description:
          'Fitting and restoring internal and external doors, wooden window frames, and custom trims.',
      },
      {
        title: 'Loft & Storage Solutions',
        description:
          'Loft conversions, attic boarding, and innovative under-stairs or alcove storage solutions.',
      },
      {
        title: 'Outdoor Carpentry',
        description:
          'Timber decking, pergolas, and wooden fencing to enhance your outdoor spaces.',
      },
    ],
    commitment:
      'We take pride in our craftsmanship and attention to detail, ensuring every project meets the highest standards. Whether you need small repairs or large-scale construction, our carpentry team delivers excellence every time.',
    mainImage: CarpentryImage,
    secondImage: CarpentryImage,
    mainImageAlt: 'A carpenter working on a custom wooden staircase',
    imageTwo: CarpentryImage2,
    imageThree: CarpentryImage3,
  };

  return (
    <main
      role='main'
      className='grid pt-8 sm:pt-10 md:pt-12 gap-12 lg:gap-24 w-full h-full'
    >
      <GeneralMainSection {...carpentryPageData} />

      <GeneralFooter title={`Carpentry`} />
    </main>
  );
}

export default CarpentryPageMainContainer;
